import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/js/bootstrap.bundle.min";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.scss";
import './locales/i18n';
import { ThemeProvider } from "./components/ThemeProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
  <ThemeProvider>
    <App />
  </ThemeProvider>
  </>
);

reportWebVitals();
